import { $remoteConfigStore, RemoteConfig } from '@lib/store';
import type { GetSpecialOffersResponse, LifestyleCategories, LifestyleCategoryType } from '@shared/api';

const MAP_TO_OFFER_TYPE: Record<LifestyleCategoryType, string[]> = {
  hotels: ['Hotel'],
  flights: ['Airline tickets'],
  transfers: ['Transfer'],
  restaurants: ['Restaurant'],
  'events-and-tickets': ['Event', 'Tickets - concerts', 'Tickets - social events', 'Tickets - sport events', 'Tickets - theatre'],
  'private-jets': ['Jet'],
  'wellness-and-beauty': ['Wellness Card'],
  shopping: ['Shopping'],
  flowers: ['Flowers'],
  'vip-meet-and-greet': ['VIP Airport'],
  other: [],
};

const MAP_TO_LSB_REQUEST_TYPE: Record<LifestyleCategoryType, string> = {
  hotels: 'hotel',
  flights: 'airline tickets',
  transfers: 'Transfer',
  restaurants: 'restaurant',
  'events-and-tickets': 'event',
  'private-jets': 'jet',
  'wellness-and-beauty': 'wellness card',
  shopping: 'shopping',
  flowers: 'flowers',
  'vip-meet-and-greet': 'vip airport',
  other: 'Profit making Travel',
};

export class LsbUtils {
  static getLifestyleCategories = (): LifestyleCategories =>
    $remoteConfigStore.events.getValue<LifestyleCategories>(RemoteConfig.LifestyleCategories);

  static getLifestyleCategoryByType = (type: LifestyleCategoryType) => this.getLifestyleCategories().find((category) => category.type === type);

  static getSpecialOffersByType = (data: { type: LifestyleCategoryType; offers: GetSpecialOffersResponse[] | null }) => {
    const types = MAP_TO_OFFER_TYPE[data.type] ?? [];
    return data.offers?.filter((offer) => types.some((type) => type.toLowerCase() === String(offer.type).toLowerCase()));
  };

  static getSpecialOfferById = (data: { id: string; offers: GetSpecialOffersResponse[] | null }) =>
    data.offers?.find((offer) => offer.id === data.id);

  static getLsbRequestType = (type: LifestyleCategoryType) => MAP_TO_LSB_REQUEST_TYPE[type];
}
